import { Component, input, inject } from '@angular/core';
import { DateAdapter } from '@angular/material/core';
import moment from 'moment';
import { PlayerDetailsViewModel } from '../../../shared/models/player.model';
import { GameService } from '../../../shared/services/game.service';
import { ScoutingService } from '../../../shared/services/scouting.service';
import { GameDetailsViewModel } from '../../../shared/models/GameModels';
import { ScoutingReportMasterData, ReportViewModel } from '../../../shared/models/ReportModels';
import { ActivatedRoute } from '@angular/router';
import { ScoutingPlayerService } from '../../../shared/services/scouting-player.service';
import { CommonModule } from '@angular/common';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { PlayerHeaderComponent } from '../../components/player-header/player-header.component';
import { MatDivider } from '@angular/material/divider';
import { GameHeaderSmallComponent } from '../../components/game-header-small/game-header-small.component';
import { ReportOverallGradesComponent } from '../../components/report-overall-grades/report-overall-grades.component';
import { MatIconModule } from '@angular/material/icon';
import { ReportOverallSkillsgroupComponent } from '../../components/report-overall-skillsgroup/report-overall-skillsgroup.component';
import { ReportOverallGradesNewComponent } from '../../components/report-overall-grades-new/report-overall-grades-new.component';
import { Observable } from 'rxjs';
import { map, shareReplay, switchMap } from 'rxjs/operators';

interface ReportDetailsVm {
  report: ReportViewModel;
  player: PlayerDetailsViewModel;
  reportMasterData: ScoutingReportMasterData;
}

@Component({
  selector: 'app-report-details',
  imports: [MatMomentDateModule, MatDivider, MatIconModule, CommonModule,
    PlayerHeaderComponent,
    GameHeaderSmallComponent,
    ReportOverallSkillsgroupComponent,
    ReportOverallGradesComponent,
    ReportOverallGradesNewComponent],
  templateUrl: './report-details.component.html',
  styleUrl: './report-details.component.css'
})
export class ReportDetailsComponent {
  ReportId = input<string>();
  PlayerId: string;
  GameId: string;
  TeamId: string;
  _reportId: string;
  Game: GameDetailsViewModel;
  Player: PlayerDetailsViewModel;
  ReportMasterData: ScoutingReportMasterData;
  Report: ReportViewModel;  
  vm$!: Observable<ReportDetailsVm>;
  mylist = [0,1,2,3,4,5];
  gameperf_texts=['-','Bad', 'Average','Good', 'Very good', 'Excellent' ];
  gameperf_colors= ['','#ff2c1c','#e9c400','yellowgreen', 'limegreen', '#1e90ff'];

  _adapter = inject(DateAdapter<any>);
  _gameService = inject(GameService);
  _reportService = inject(ScoutingService);
  route = inject(ActivatedRoute);
  _scoutingplayerService = inject(ScoutingPlayerService);

    

    ngOnInit(): void {
      
      this._adapter.setLocale(localStorage.getItem("language")?.substring(0, 2) ?? 'en');  

      //console.log("EditReportComponent ngOnInit: ReportId - " + this.ReportId());
      //This is for opening an old report
      if (!this.ReportId()) {
        this._reportId = this.route.snapshot.paramMap.get('ReportId') ?? "";
      } else {
        this._reportId = this.ReportId() ?? "";
      }

      if (this._reportId) {
        this.vm$ = this._reportService.getReport(this._reportId).pipe(
          switchMap((report: ReportViewModel) => {
            const player = this.createPlayerFromReport(report);
            console.log(report);
            return this._scoutingplayerService.getReportMasterDataForPosition(report.SCReport.Player.PositionId.toString()).pipe(
              map((reportMasterData: ScoutingReportMasterData) => ({ report, player, reportMasterData }))
            );
          }),
          shareReplay(1)
        );
      }
      
    }

  private createPlayerFromReport(report: ReportViewModel): PlayerDetailsViewModel {
    const tmpPlayer = new PlayerDetailsViewModel();
    tmpPlayer.Player = report.SCReport.Player;
    tmpPlayer.PlayerAgeDays = report.PlayerAgeDays;
    tmpPlayer.PlayerAgeMonths = report.PlayerAgeMonths;
    tmpPlayer.PlayerAgeYears = report.PlayerAgeYears;
    return tmpPlayer;
  }

  getTextType(report: ReportViewModel, typeId: number): string{
    var text= report.SCReport.ReportTexts.find(text=>text.TextTypeId==typeId);
    if(text==undefined)
      return "";
    else
      return text.Text;

  }

  getTimeAgo(report: ReportViewModel){
    moment.locale(localStorage.getItem("language")?.substring(0, 2) ?? 'en');
    return moment(report.SCReport.ReportDate).fromNow();
  }

  getTextClass(report: ReportViewModel): string{
    var text = report.SCReport.ReportTexts.find(text=>text.TextTypeId==1);
    if(text && text.Text.length>200){
      return "longtextclass";
    }
    else{
      return "shorttextclass";
    }
  }

}
